import React, { useContext, useEffect, useState } from 'react';
import Modal from 'react-responsive-modal';
import {
	Button,
	Form,
	FormGroup,
	Label,
	Col,
} from 'reactstrap';
// import Datepicker from 'react-datepicker';
import Select from 'react-select';
import Datetime from 'react-datetime';
import { Link } from 'react-router-dom';
import NumberFormat from 'react-number-format';
import { Get, JENIS_DUSUN, Post } from '../../function/Koneksi';
import { generateAlamat, Tanggal } from '../../function/Format';

const ModalSuratPindahNikah = ({ data, optionData, setAlert, isOpen, setIsOpen, statusRefresh, setStatusRefresh, propsData, kiosk }) => {
	const dateFormat = require('dateformat');

	const frmDex = {
		uuid: "",
		agama: "",
		alamat: "",
		detail: [],
		id_jenis: "",
		jenis_kelamin: "",
		kewarganegaraan: "Indonesia",
		kk: "",
		nama_pemohon: "",
		nik: "",
		nik_pelapor: "",
		pekerjaan: "",
		pendidikan_terakhir: "",
		status_perkawinan: "",
		tanggal_lahir: "",
		tempat_lahir: "",
		tujuan_pembuatan: "",

		//detail
		nama_pasangan: "",
		nama_nasab_p1: "",
		nama_nasab_p2: "",
		jenis_kelamin_pasangan: "",
		tempat_lahir_pasangan: "",
		tanggal_lahir_pasangan: "",
		pekerjaan_pasangan: "",
		agama_pasangan: "",
		nik_pasangan: "",
		alamat_pasangan: "",
		tempat_nikah: ""
	};

	const initFormData = {
		frmNik: optionData.frmNik,
		frmNik2: optionData.frmNik2,
		frmJk: optionData.frmJk,
		frmPkr: optionData.frmPkr,
		frmAgm: optionData.frmAgm,
		tmplistPenduduk: optionData.tmplistPenduduk,
		tmplistPenduduk3: optionData.tmplistPenduduk3,
		// frmShdk: optionData.frmShdk,
		nikStat: null,
		nik2Stat: null,
		jkkkStat: optionData.jkkkStat,
		agmStat: optionData.agmStat,
		detail: [],
		status: {
			form: false,
			btnForm: false,
			btnAksi: [],
		},
		showBio: optionData.showBio,
		showBio2: optionData.showBio2,
		formPasangan: 'none',
		show: false,
		basicTitle: "",
		basicType: "default",
		pesanAlert: "",
	}

	const [formData, setFormData] = useState(initFormData)
	const [props, setProps] = useState(propsData)
	const [kioskMode, setKioskMode] = useState(kiosk)
	const [dt, setDt] = useState(data ? data : frmDex)
	const [draggable, setDraggable] = useState({
		isDown: false,
		startY: null,
		scrollUp: null,
	})

	useEffect(() => {
		if (document.getElementById("modalForm")) {
			document.getElementById("modalForm").reset()
		}
		console.log(data);
		console.log(optionData);

		setDt(data ? data : frmDex)
		setFormData(data ? {
			...initFormData,
			frmNik: optionData.frmNik,
			frmNik2: optionData.frmNik2,
			frmJk: optionData.frmJk,
			frmPkr: optionData.frmPkr,
			frmAgm: optionData.frmAgm,
			jkkkStat: optionData.jkkkStat,
			agmStat: optionData.agmStat,
			nikStat: optionData.nikStat,
			nik2Stat: optionData.nik2Stat,
			status: optionData.status,
			showBio: optionData.showBio,
			showBio2: optionData.showBio2,
			formPasangan: optionData.formPasangan,
		} : initFormData)
	}, [isOpen])

	const handleInputChangeNIK = (e, fld) => {
		if (e && kioskMode == false || e && fld == "nik2") {
			let nikStat = { value: e, label: e };

			Post("penduduk", null, { nik: e }, datanik => {
				let frmNik = [];
				let tmplistPenduduk = {}
				datanik.data.results.data.forEach(dt => {
					frmNik.push({ value: dt.id, label: dt.id + ' (' + dt.nama + ')' });
					tmplistPenduduk = {
						...tmplistPenduduk,
						[dt.id]: dt
					}
				});

				switch (fld) {
					case "nik":
						setFormData({
							...formData,
							frmNik,
							tmplistPenduduk,
							nikStat
						})
						break;
					case "nik2":
						setFormData({
							...formData,
							frmNik2: frmNik,
							tmplistPenduduk3: tmplistPenduduk,
							nik2Stat: nikStat
						})
						break;

					default:
						break;
				}

			});

		}
	};

	const changeSelectValue = (e, sel) => {
		switch (sel) {
			case "jk":
				setDt({
					...dt,
					jk: e.value
				})
				setFormData({
					...formData,
					jkkkStat: e
				})
				// this.setState({
				// 	jkkkStat: e,
				// 	dt: {
				// 		...this.state.dt,
				// 		jk: e.value,
				// 	},
				// });

				// // For testing
				// if (this.props.selectOnChangeJenisKelaminPasangan) {
				// 	this.props.selectOnChangeJenisKelaminPasangan(e)
				// }
				break;
			case "agama":
				setDt({
					...dt,
					agama_pasangan: e.value
				})
				setFormData({
					...formData,
					agmStat: e
				})
				break;
			case "pekerjaan_pasangan":
				setDt({
					...dt,
					pekerjaan_pasangan: e
				})
				break;
			default:
				// no default
				break;
		}
	}

	const dataPasangan = () => {
		let showBio2 = true
		if (formData.nik2Stat == null) {
			showBio2 = !formData.showBio2
		}

		let formPasangan = formData.formPasangan === "" ? "none" : "";

		setDt({
			...dt,
			nama_nasab_p2: "",
			nama_pasangan: "",
			jenis_kelamin_pasangan: "",
			tempat_lahir_pasangan: "",
			tanggal_lahir_pasangan: null,
			pekerjaan_pasangan: null,
			agama_pasangan: null,
			nik_pasangan: "",
			alamat_pasangan: "",
			alamat_kk_pasangan: "",
		})
		setFormData({
			...formData,
			showBio2,
			formPasangan,
			agmStat: null,
			jkkkStat: null,
			nik2Stat: null
		})
	}

	const changeInputText = (e, fld) => {
		setDt({
			...dt,
			[fld]: e.target.value,
		})
	};

	const gantiTgl = (date, fld) => {
		if (typeof date._isValid !== 'undefined') {
			setDt({
				...dt,
				[fld]: new Date(date.format('YYYY-MM-DD'))
			})
		}
	}

	const getPenduduk = (e, jns) => {
		if (e) {

            if (kioskMode) {
                props.setLoadingPreview(true)
            }
            else{
                setAlert({
                    loadingPreview: true
                })
            }

			Get("penduduk/find", e.value, data => {
                if(data.results){
                    const alamat = generateAlamat(data.results);
                    let alamat_kk = "";
                
                    if(data.results.data_kk){
                        alamat_kk = data.results.data_kk.alamat
                    }

                    if (jns === "nik") {
                        setDt({
                            ...dt,
                            nik: data.results.id,
                            nik_pelapor: data.results.id,
                            kk: data.results.id_kk,
                            nama: data.results.nama,
                            nama_pemohon: data.results.nama,
                            tempat_lahir: data.results.tempat_lahir,
                            tanggal_lahir: data.results.tanggal_lahir,
                            pekerjaan: data.results.data_pekerjaan.nama,
                            jenis_kelamin: data.results.jk,
                            pendidikan_terakhir: data.results.data_pendidikan_terakhir.nama,
                            agama: data.results.data_agama.nama,
                            status_perkawinan: data.results.status_perkawinan,
                            alamat: alamat,
                            alamat_kk: alamat_kk,
                            nama_nasab_p1: data.results.nama_ayah_kandung,
                            detail: [],
                        })
                        setFormData({
                            ...formData,
                            nikStat: e,
                            showBio: true,
                        })

                        if (kioskMode) {
                            props.setLoadingPreview(false)
                        }
                        else{
                            setAlert({
                                loadingPreview: false
                            })
                        }
        
                    } else if (jns === "nik2") {
                        setFormData({
                            ...formData,
                            nik2Stat: e,
                            jkkkStat: { value: data.results.jk, label: data.results.jenis_kelamin },
                            agmStat: { value: data.results.data_agama.nama, label: data.results.data_agama.nama },
                            showBio2: true,
                        })
                        setDt({
                            ...dt,
                            nik_pasangan: data.results.id,
                            kk_pasangan: data.results.id_kk,
                            nama_pasangan: data.results.nama,
                            tempat_lahir_pasangan: data.results.tempat_lahir,
                            tanggal_lahir_pasangan: data.results.tanggal_lahir,
                            pekerjaan_pasangan: {
                                value: data.results.data_pekerjaan.nama,
                                label: data.results.data_pekerjaan.nama,
                            },
                            jenis_kelamin_pasangan: data.results.jk,
                            pendidikan_terakhir_pasangan: data.results.data_pendidikan_terakhir.nama,
                            agama_pasangan: data.results.data_agama.nama,
                            status_perkawinan_pasangan: data.results.status_perkawinan,
                            nama_nasab_p2: data.results.nama_ayah_kandung,
                            alamat_pasangan: alamat,
                            alamat_kk_pasangan: alamat_kk,
                            kewarganegaraan_pasangan: 'WNI',
                        })

                        if (kioskMode) {
                            props.setLoadingPreview(false)
                        }
                        else{
                            setAlert({
                                loadingPreview: false
                            })
                        }
                    } 
                }
                else{
                    if (kioskMode) {
                        props.setLoadingPreview(true)
                    }
                    else{
                        setAlert({
                            loadingPreview: true
                        })
                    }
                }
            })

		} else {
			switch (jns) {
				case "nik":
					// setDt(frmDex)
					setDt({
						...dt,
						nik: '',
						nik_pelapor: '',
						kk: '',
						nama: '',
						nama_pemohon: '',
						tempat_lahir: '',
						tanggal_lahir: null,
						pekerjaan: '',
						jenis_kelamin: '',
						pendidikan_terakhir: '',
						agama: '',
						status_perkawinan: '',
						alamat: '',
						nama_nasab_p1: '',
					})
					setFormData({
						...formData,
						showBio: false,
						nikStat: null,
					})
					break;
				case "nik2":
					setDt({
						...dt,
						nik_pasangan: '',
						nama_pasangan: '',
						tempat_lahir_pasangan: '',
						tanggal_lahir_pasangan: new Date(),
						pekerjaan_pasangan: null,
						pendidikan_terakhir_pasangan: '',
						agama_pasangan: '',
						status_perkawinan_pasangan: '',
						jenis_kelamin_pasangan: '',
						alamat_pasangan: '',
					})
					setFormData({
						...formData,
						showBio2: false,
						nik2Stat: null
					})
					break;
				case "pengikut":
					setFormData({
						...formData,
						nik3Stat: null
					})
					break;
				default:
					break;
			}
		}
	};

	const simpan = (e) => {
		e.preventDefault();

        if (kioskMode){
            props.setLoadingPreview(true)
        }
        else{
            setAlert({
                loadingPreview: true
            })
        }
        
		let validasiPemohon = false;
        let validasiPasangan = false;

        // validasi pemohon
        if (formData.nikStat != null) {
            validasiPemohon = true;
        }

		// validasi pasangan
		// Input manual data pasangan
        if (formData.formPasangan !== "none") {
            if (dt.nik_pasangan !== '' && dt.pekerjaan_pasangan !== null && formData.jkkkStat !== null && formData.agmStat !== null) {
                validasiPasangan = true;
            }
        } else { // data pasangan otomatis
            if (formData.nik2Stat !== null) {
                validasiPasangan = true;
            }
        }

		if (validasiPemohon && validasiPasangan) {
            //detail
			let tanggal_lahir_pasangan = new Date(dt.tanggal_lahir_pasangan);
			console.log(tanggal_lahir_pasangan);

            let formDetail = [
                {
                    nama_item: "nama_pasangan",
                    isi_item: document.getElementById("nama_pasangan").value
                },
                {
                    nama_item: "nama_nasab_p1",
                    isi_item: document.getElementById("nama_nasab_p1").value
                },
                {
                    nama_item: "nama_nasab_p2",
                    isi_item: document.getElementById("nama_nasab_p2").value
                },
                {
                    nama_item: "jenis_kelamin_pasangan",
                    isi_item: formData.jkkkStat.value
                },
                {
                    nama_item: "tempat_lahir_pasangan",
                    isi_item: document.getElementById("tempat_lahir_pasangan").value
                },
                {
                    nama_item: "tanggal_lahir_pasangan",
                    isi_item: dateFormat(tanggal_lahir_pasangan, 'yyyy-mm-dd'),
                },
                {
                    nama_item: "pekerjaan_pasangan",
                    isi_item: dt.pekerjaan_pasangan.label
                },
                {
                    nama_item: "agama_pasangan",
                    isi_item: formData.agmStat.label,
                },
                {
                    nama_item: "nik_pasangan",
                    isi_item: dt.nik_pasangan
                },
                {
                    nama_item: "alamat_pasangan",
                    isi_item: document.getElementById("alamat_pasangan").value
                },
                {
                    nama_item: "alamat_kk_pasangan",
                    isi_item: document.getElementById("alamat_kk_pasangan").value
                },
                {
                    nama_item: "tempat_nikah",
                    isi_item: document.getElementById("tempat_nikah").value
                }
            ];

			let tanggal_lahir = new Date(dt.tanggal_lahir);

			let bodyRaw = {
				...dt,
				tanggal_lahir: dateFormat(tanggal_lahir, 'yyyy-mm-dd'),
                tujuan_pembuatan: "Surat Pengantar Pindah Nikah",
                detail: formDetail
            };

			delete bodyRaw.nama_pasangan
			delete bodyRaw.nama_nasab_p1
			delete bodyRaw.nama_nasab_p2
			delete bodyRaw.jenis_kelamin_pasangan
			delete bodyRaw.tempat_lahir_pasangan
			delete bodyRaw.tanggal_lahir_pasangan
			delete bodyRaw.pekerjaan_pasangan
			delete bodyRaw.agama_pasangan
			delete bodyRaw.nik_pasangan
			delete bodyRaw.alamat_pasangan
			delete bodyRaw.tempat_nikah

			if (dt.uuid === '') {
				if (kioskMode) {
					bodyRaw.id_jenis = props.id_jenis
				} else {
					bodyRaw.id_jenis = props.location.state.uuid
				}
			}

			if (bodyRaw.detail.length > 0) {
				let psn = "";
				let resstat = 204;
				let metode = "create";
				if (bodyRaw.uuid === "") {
					psn = "Tambah";
					resstat = 201;
					bodyRaw.uuid = null;
				} else {
					psn = "Ubah";
					resstat = 200;
					metode = "update";
				}

				Post(
					"surat-keterangan/grup/" + metode + "/with-detail",
					bodyRaw.uuid,
					bodyRaw,
					res => {

						// For testing
						if (props.resSubmit) {
							props.resSubmit(res.status)
						}

						// this.tutupForm();
						setFormData({
							...formData,
							status: {
								...formData.status,
								btnForm: false,
								form: false,
							}
						})
						setIsOpen(false)

						// Kalau mode kiosk
                        if (kioskMode) {
                            if (res.status === resstat) {
                                let dataAntrian = {
                                    nama: props.data.results.nama,
                                    nik: props.data.results.id,
                                    keterangan: '',
                                    uuid_surat:res.data.results.uuid_surat,
                                    kode_surat:res.data.results.kode_surat,
                                };
                      
                                // Set Data Surat
                                props.getDataSurat(res.data.results);

								setTimeout(function () {
									Get('persetujuan/kiosk/' + dataAntrian.uuid_surat + '/' + props.id_jenis, null, (res2) => {
										
										props.setLoadingPreview(false)

										if (res2.code === 201) {
											props.getAntrian('Surat Pengantar Pindah Nikah', 'berhasil', false, dataAntrian);
										}
										else {
											props.getAntrian('Surat Pengantar Pindah Nikah', 'gagal');
										}
									});
								}.bind(this),1000)
                            }
                            else{
								props.setLoadingPreview(false)
                              	props.getAntrian('Surat Pengantar Pindah Nikah', 'gagal');
                            }

						} else { // Kalau bukan kiosk
							if (res.status === resstat) {
                                const alertData = {
                                  get_data_surat:{
                                    uuid_surat:res.data.results.uuid_surat,
                                    kode_surat:res.data.results.kode_surat,
                                  },
                                  status:{
                                    frmPreviewDraft: true,
                                    jenis_form: psn,
                                  }
                                  // show: true,
                                  // basicType: "success",
                                  // basicTitle: "Data Surat Keterangan Kematian V2",
                                  // pesanAlert: "Berhasil " + psn + " Data",
                                  // successAlert: true
                                };
								setAlert({
								  	loadingPreview: false
								})
                                setAlert(alertData);
							} else {
								const alertData = {
									show: true,
									basicType: "danger",
									basicTitle: "Data Surat Pengantar Pindah Nikah",
									pesanAlert: "Gagal " + psn + " Data"
								}
								setAlert({
								  	loadingPreview: false
								})
								setAlert(alertData)
							}

							// Refresh list
							setStatusRefresh(true)
						}
					}
				);
			}

		} else {
			if (kioskMode){
				props.getAntrian('Surat Pengantar Pindah Nikah', 'gagal', true);
				props.setLoadingPreview(false)
			}
			else{
				const alertData = {
					show: true,
					basicType: "info",
					basicTitle: "Data Belum Lengkap",
					pesanAlert: "Mohon isi seluruh data dengan benar"
				}
				setAlert({
					loadingPreview: false
				})
				setAlert(alertData)
			}
		}

	};

	return (
		<Modal
			classNames={{ overlay: 'card-scrollable' }}
			open={isOpen}
			onClose={() => {
				setIsOpen(false)
			}}
			closeOnEsc={false}
			closeOnOverlayClick={false}
			styles={{ modal: { width: "80%", maxwidth: 'unset' } }}
		>
			<Form
				id="modalForm"
				data-testid="form-create"
				className="theme-form"
				onSubmit={simpan}
			>
				<div
					onMouseDown={(e) => {
						let slider = document.querySelector('.card-scrollable');
						setDraggable({
							isDown: true,
							startY: e.pageY - slider.offsetTop,
							scrollUp: slider.scrollTop,
						})
					}}
					onMouseLeave={() => {
						setDraggable({
							...draggable,
							isDown: false
						})
					}}
					onMouseUp={() => {
						setDraggable({
							...draggable,
							isDown: false
						})
					}}
					onMouseMove={(e) => {
						e.preventDefault();

						let slider = document.querySelector('.card-scrollable');

						if (!draggable.isDown) {
							return;
						}

						const y = e.pageY - slider.offsetTop;
						const startY = draggable.startY;
						const walk = y - startY;
						slider.scrollTop = draggable.scrollUp - walk;
					}}
				>
					<div className="modal-header">
						<h5 className="modal-title">{dt.uuid == '' ? 'Tambah' : 'Edit'} Surat Pengantar Pindah Nikah</h5>
					</div>
					<div className="modal-body">
						<input
							className="form-control"
							id="uuid"
							type="hidden"
							placeholder=""
							defaultValue={dt.uuid}
						/>
						<FormGroup className="row">
							<Label
								className="col-sm-3 col-form-label"
								htmlFor="nik"
							>
								NIK Pemohon{" "}
							</Label>
							<Col sm="9">
								<div data-testid="selectNIK">
									<Select
										inputId="nik"
										classNamePrefix="select"
										onChange={e => {
											getPenduduk(e, "nik");
										}}
										defaultValue={formData.nikStat}
										value={formData.nikStat}
										name="penduduk"
										onInputChange={e => handleInputChangeNIK(e, "nik")}
										options={formData.frmNik}
										placeholder="Pilih NIK Pemohon"
										isClearable
									/>
								</div>
							</Col>
						</FormGroup>

						<div
							style={{ display: formData.showBio === false ? "none" : "" }}
						>
							<Label
								className="col-sm-12 col-form-label font-weight-bold pl-0"
								htmlFor="inputEmail3"
							>
								Detail Data Pemohon
							</Label>
							<FormGroup className="row">
								<Label
									className="col-sm-3 col-form-label"
									htmlFor="inputEmail3"
								>
									Nama Pemohon
								</Label>
								<Col sm="9">
									<input
										className="form-control"
										id="nama_pemohon"
										readOnly
										type="text"
										placeholder="nama_pemohon"
										value={dt.nama_pemohon}
										style={{ backgroundColor: "#c9d1d8" }}
										disabled
									/>
								</Col>
							</FormGroup>
							<FormGroup className="row">
								<Label
									className="col-sm-3 col-form-label"
									htmlFor="inputEmail3"
								>
									Nama Nasab
								</Label>
								<Col sm="9">
									<input
										className="form-control"
										id="nama_nasab_p1"
										type="text"
										required
										readOnly
										placeholder="Nama Nasab"
										defaultValue={dt.nama_nasab_p1}
										style={{ backgroundColor: "#c9d1d8" }}
										disabled
									/>
								</Col>
							</FormGroup>
							{/* <FormGroup className="row">
                  <Label
                    className="col-sm-3 col-form-label"
                    htmlFor="inputEmail3"
                  >
                    NIK
                  </Label>
                  <Col sm="9"> */}
							<input
								className="form-control"
								id="nik"
								type="hidden"
								readOnly
								placeholder="NIK"
								value={dt.nik}
							/>
							{/* </Col>
                </FormGroup> */}
							{/* <FormGroup className="row">
                  <Label
                    className="col-sm-3 col-form-label"
                    htmlFor="inputEmail3"
                  >
                    KK
                  </Label>
                  <Col sm="9"> */}
							<input
								className="form-control"
								id="kk"
								type="hidden"
								readOnly
								placeholder="kk"
								value={dt.kk}
							/>
							{/* </Col>
                </FormGroup> */}

							<FormGroup className="row">
								<Label
									className="col-sm-3 col-form-label"
									htmlFor="inputEmail3"
								>
									Tempat Lahir
								</Label>
								<Col sm="9">
									<input
										className="form-control"
										readOnly
										id="tempat_lahir"
										type="text"
										placeholder="Tempat lahir"
										value={dt.tempat_lahir}
										style={{ backgroundColor: "#c9d1d8" }}
										disabled
									/>
								</Col>
							</FormGroup>
							<FormGroup className="row">
								<Label
									className="col-sm-3 col-form-label"
									htmlFor="inputEmail3"
								>
									Tanggal Lahir
								</Label>
								<Col sm="9">
									<input
										className="form-control"
										id="tanggal_lahir"
										readOnly
										type="text"
										placeholder="Tanggal Lahir"
										value={dt.tanggal_lahir}
										style={{ backgroundColor: "#c9d1d8" }}
										disabled
									/>
								</Col>
							</FormGroup>
							{/* <FormGroup className="row">
                  <Label
                    className="col-sm-3 col-form-label"
                    htmlFor="inputEmail3"
                  >
                    Jenis Kelamin
                  </Label>
                  <Col sm="9"> */}
							<input
								className="form-control"
								id="jenis_kelamin"
								readOnly
								type="hidden"
								placeholder="jenis_kelamin"
								value={dt.jenis_kelamin}
							/>
							{/* </Col>
                </FormGroup> */}
							{/* <FormGroup className="row">
                  <Label
                    className="col-sm-3 col-form-label"
                    htmlFor="inputEmail3"
                  >
                    Pekerjaan
                  </Label>
                  <Col sm="9"> */}
							<input
								className="form-control"
								readOnly
								id="pekerjaan"
								type="hidden"
								placeholder="Pekerjaan"
								value={dt.pekerjaan}
							/>
							{/* </Col>
                </FormGroup> */}
							{/* <FormGroup className="row">
                  <Label
                    className="col-sm-3 col-form-label"
                    htmlFor="inputEmail3"
                  >
                    Pendidikan Terakhir
                  </Label>
                  <Col sm="9"> */}
							<input
								className="form-control"
								id="pendidikan_terakhir"
								readOnly
								type="hidden"
								placeholder="Pendidikan Terakhir"
								value={dt.pendidikan_terakhir}
							/>
							{/* </Col>
                </FormGroup> */}
							{/* <FormGroup className="row">
                  <Label
                    className="col-sm-3 col-form-label"
                    htmlFor="inputEmail3"
                  >
                    Agama
                  </Label>
                  <Col sm="9"> */}
							<input
								className="form-control"
								id="agama"
								readOnly
								type="hidden"
								placeholder="Agama"
								value={dt.agama}
							/>
							{/* </Col>
                </FormGroup> */}
							<FormGroup className="row">
								<Label
									className="col-sm-3 col-form-label"
									htmlFor="inputEmail3"
								>
									Status Perkawinan
								</Label>
								<Col sm="9">
									<input
										className="form-control"
										id="status_perkawinan"
										type="text"
										readOnly
										placeholder="Status Perkawinan"
										value={dt.status_perkawinan}

										style={{ backgroundColor: "#c9d1d8" }}
										disabled
									/>
								</Col>
							</FormGroup>
                            <FormGroup className="row">
                                <Label className="col-sm-3 col-form-label" htmlFor="inputEmail3">
                                    Alamat
                                </Label>
                                <Col sm="9">
                                    <input
                                        className="form-control"
                                        id="alamat_kk"
                                        type="text"
                                        // placeholder="Tempat Lahir"
                                        value={dt.alamat_kk}
                                        readOnly
                                        style={{ backgroundColor: "#c9d1d8" }}
                                        disabled
                                    />
                                </Col>
                            </FormGroup>
                            <FormGroup className="row">
                                <Label className="col-sm-3 col-form-label" htmlFor="inputEmail3">
                                    Wilayah
                                </Label>
                                <Col sm="9">
                                    <input
                                        className="form-control"
                                        id="alamat"
                                        type="text"
                                        // placeholder="Tempat Lahir"
                                        value={dt.alamat}
                                        readOnly
                                        style={{ backgroundColor: "#c9d1d8" }}
                                        disabled
                                    />
                                    <small><font color="red">* Jika data wilayah kosong, silahkan perbaiki data alamat kartu keluarga dan pastikan data lengkap terlebih dahulu</font></small>
                                </Col>
                            </FormGroup>
							{/* <FormGroup className="row">
                  <Label
                    className="col-sm-3 col-form-label"
                    htmlFor="inputEmail3"
                  >
                    Alamat
                  </Label>
                  <Col sm="9"> */}
							<input
								className="form-control"
								id="alamat"
								type="hidden"
								readOnly
								placeholder="Alamat"
								value={dt.alamat}
							/>
							{/* </Col>
                </FormGroup> */}
							{/* <FormGroup className="row">
                  <Label
                    className="col-sm-3 col-form-label"
                    htmlFor="inputEmail3"
                  >
                    Kewarganegaraan
                  </Label>
                  <Col sm="9"> */}
							<input
								className="form-control"
								id="kewarganegaraan"
								type="hidden"
								readOnly={true}
								placeholder="Kewarganegaraan"
								value={dt.kewarganegaraan}
							/>
							{/* </Col>
                </FormGroup> */}
						</div>
						<hr />
						<FormGroup className="row">
							<Label
								className="col-sm-3 col-form-label"
								htmlFor="nik2"
							>
								NIK Pasangan{" "}
							</Label>
							<Col sm="9">
								{formData.formPasangan === "none" ? (
									<div data-testid="selectNIK2">
										<Select
											inputId="nik2"
											isDisabled={formData.status.select}
											classNamePrefix="select"
											onChange={e => {
												getPenduduk(e, "nik2");
											}}
											defaultValue={formData.nik2Stat}
											value={formData.nik2Stat}
											name="penduduk"
											onInputChange={e => handleInputChangeNIK(e, "nik2")}
											options={formData.frmNik2}
											placeholder="Pilih NIK Pasangan"
											isClearable
										/>
									</div>
								) : (
									<></>
								)}
								<input
									data-testid="nik_pasangan"
									name="nik_pasangan"
									className="form-control"
									id="nik_pasangan"
									// type={
									// 	formData.formPasangan === "none" ? "hidden" : "number"
									// }
									type={formData.formPasangan === "none" ? "hidden" : "text"}
									pattern="\d{1,16}"
									maxLength={16}
									minLength={16}
									required
									placeholder="Masukkan NIK Pasangan (16 angka)"
									defaultValue={dt.nik_pasangan}
									value={dt.nik_pasangan}
									onChange={e => changeInputText(e, "nik_pasangan")}
								/>
								<small id="emailHelp" className="form-text text-muted">
									Data NIK {formData.formPasangan === "none" ? "tidak" : ""}{" "}
									tersedia?{" "}
									<span 
										style={{ cursor: "pointer", color: "#0000ff" }}
										onClick={() => {
											if (formData.formPasangan === "none") {
												if (props.getJenisInput) {
													props.getJenisInput("manual")
												}
											}
											else {
												if (props.getJenisInput) {
													props.getJenisInput("auto")
												}
											}
											dataPasangan()
										}}
									>
										Klik disini
									</span>
								</small>
							</Col>
						</FormGroup>
						<div
							style={{ display: formData.showBio2 === false ? "none" : "" }}
						>
							<Label
								className="col-sm-12 col-form-label font-weight-bold pl-0"
								htmlFor="inputEmail3"
							>
								Detail Data Pasangan
							</Label>
							<FormGroup className="row">
								<Label
									className="col-sm-3 col-form-label"
									htmlFor="inputEmail3"
								>
									Nama Pasangan
								</Label>
								<Col sm="9">
									<input
										data-testid="nama_pasangan"
										name="nama_pasangan"
										className="form-control"
										id="nama_pasangan"
										type="text"
										required
										readOnly={formData.formPasangan === "" ? false : true}
										placeholder="Contoh : Toni"
										defaultValue={dt.nama_pasangan}
										value={dt.nama_pasangan}
										onChange={e => changeInputText(e, "nama_pasangan")}

										style={formData.formPasangan === "" ? { backgroundColor: "" } : { backgroundColor: "#c9d1d8" }}
										disabled={formData.formPasangan === "" ? false : true}
									/>
								</Col>
							</FormGroup>
							<FormGroup className="row">
								<Label
									className="col-sm-3 col-form-label"
									htmlFor="inputEmail3"
								>
									Nama Nasab Pasangan
								</Label>
								<Col sm="9">
									<input
										data-testid="nama_nasab_p2"
										name="nama_nasab_p2"
										className="form-control"
										id="nama_nasab_p2"
										type="text"
										required
										readOnly={formData.formPasangan === "" ? false : true}
										placeholder="Masukkan nama ayah dari pasangan"
										defaultValue={dt.nama_nasab_p2}
										value={dt.nama_nasab_p2}
										onChange={e => changeInputText(e, "nama_nasab_p2")}

										style={formData.formPasangan === "" ? { backgroundColor: "" } : { backgroundColor: "#c9d1d8" }}
										disabled={formData.formPasangan === "" ? false : true}
									/>
								</Col>
							</FormGroup>
							<FormGroup className="row">
								<Label
									className="col-sm-3 col-form-label"
									htmlFor="inputEmail3"
								>
									Jenis Kelamin Pasangan
								</Label>
								<Col sm="9">
									{/* <input
                      className="form-control"
                      id="jenis_kelamin_pasangan"
                      type="text"
                      readOnly={formData.formPasangan ===  "" ? false : true}
                      placeholder="jenis_kelamin"
                      value={dt.jenis_kelamin_pasangan}
                      defaultValue={dt.jenis_kelamin_pasangan}
                      onChange={e =>
                        changeInputText(e, "jenis_kelamin_pasangan")
                      }

                      style={formData.formPasangan ===  "" ? { backgroundColor:"" } : { backgroundColor:"#c9d1d8"}}
                      disabled={formData.formPasangan ===  "" ? false : true}
                    /> */}
									{formData.formPasangan === "" ? (
										<div data-testid="selectJenisKelamin">
											<Select
												inputId="jenis_kelamin_pasangan"
												id="jenis_kelamin_pasangan"
												isDisabled={formData.formPasangan === "" ? false : true}
												classNamePrefix="select"
												onChange={((e) => { changeSelectValue(e, 'jk') })}
												defaultValue={formData.jkkkStat}
												value={formData.jkkkStat}
												name="Jenis Kelamin"
												options={formData.frmJk}
												placeholder="Pilih Jenis Kelamin"
												isClearable
											/>
										</div>
									) : (
										<input
											id="jenis_kelamin_pasangan"
											type="text"
											className="form-control"
											readOnly
											value={dt.jenis_kelamin_pasangan}
											style={{ backgroundColor: "#c9d1d8" }}
										/>
									)}
								</Col>
							</FormGroup>

							<FormGroup className="row">
								<Label
									className="col-sm-3 col-form-label"
									htmlFor="inputEmail3"
								>
									Tempat Lahir Pasangan
								</Label>
								<Col sm="9">
									<input
										data-testid="tempat_lahir_pasangan"
										name="tempat_lahir_pasangan"
										className="form-control"
										id="tempat_lahir_pasangan"
										type="text"
										required
										readOnly={formData.formPasangan === "" ? false : true}
										placeholder="Contoh : Jakarta"
										defaultValue={dt.tempat_lahir_pasangan}
										value={dt.tempat_lahir_pasangan}
										onChange={e =>
											changeInputText(e, "tempat_lahir_pasangan")
										}

										style={formData.formPasangan === "" ? { backgroundColor: "" } : { backgroundColor: "#c9d1d8" }}
										disabled={formData.formPasangan === "" ? false : true}
									/>
								</Col>
							</FormGroup>
							<FormGroup className="row">
								<Label
									className="col-sm-3 col-form-label"
									htmlFor="inputEmail3"
								>
									Tanggal Lahir Pasangan
								</Label>
								<Col sm="9">
									{
										formData.formPasangan === ""
											?
											<Datetime
												inputProps={{ "data-testid": "tanggal_lahir_pasangan", placeholder: 'Klik disini untuk memilih tanggal', required: true }}
												// data-testid="tanggal_lahir_pasangan"
												inputId="tanggal_lahir_pasangan"
												name="tanggal_lahir_pasangan"
												locale="id-ID"
												input={true}
												timeFormat={false}
												closeOnTab={true}
												closeOnSelect={true}
												dateFormat="yyyy-MM-DD"
												initialValue={dt.tanggal_lahir_pasangan}
												value={dt.tanggal_lahir_pasangan}
												onChange={(e) => {
													gantiTgl(e, 'tanggal_lahir_pasangan');
												}}
											/>
											:
											<input
												className="form-control"
												id="tanggal_lahir_pasangan"
												type="text"
												readOnly
												placeholder="Tanggal Lahir"
												value={dt.tanggal_lahir_pasangan}
												defaultValue={dt.tanggal_lahir_pasangan}
												style={formData.formPasangan === "" ? { backgroundColor: "" } : { backgroundColor: "#c9d1d8" }}
												disabled={formData.formPasangan === "" ? false : true}
											/>
									}


									{/* <input
                      className="form-control"
                      id="tanggal_lahir_pasangan"
                      type={formData.formPasangan ===  "" ? "date" : "text"}
                      readOnly={formData.formPasangan ===  "" ? false : true}
                      placeholder="Tanggal Lahir"
                      value={dt.tanggal_lahir_pasangan}
                      defaultValue={dt.tanggal_lahir_pasangan}
                      onChange={e =>
                        changeInputText(e, "tanggal_lahir_pasangan")
                      }
                      required={formData.formPasangan != "none" ? true : false}
                      style={formData.formPasangan ===  "" ? { backgroundColor:"" } : { backgroundColor:"#c9d1d8"}}
                      disabled={formData.formPasangan ===  "" ? false : true}
                    /> */}
								</Col>
							</FormGroup>
							<FormGroup className="row">
								<Label
									className="col-sm-3 col-form-label"
									htmlFor="inputEmail3"
								>
									Pekerjaan Pasangan
								</Label>
								<Col sm="9">
									{formData.formPasangan === "" ? (
										<div data-testid="selectPekerjaan">
											<Select
												inputId="pekerjaan_pasangan"
												classNamePrefix="select"
												onChange={e => {
													changeSelectValue(e, "pekerjaan_pasangan");
												}}
												value={dt.pekerjaan_pasangan}
												name="pekerjaan_pasangan"
												options={formData.frmPkr}
												placeholder="Pilih Pekerjaan Pasangan"
												isClearable
											/>
										</div>
									) : (
										<input
											id="pekerjaan_pasangan"
											type="text"
											className="form-control"
											readOnly
											value={dt.pekerjaan_pasangan ? dt.pekerjaan_pasangan.label : ''}
											style={{ backgroundColor: "#c9d1d8" }}
										/>
									)
									}
								</Col>
							</FormGroup>
							<FormGroup className="row">
								<Label
									className="col-sm-3 col-form-label"
									htmlFor="inputEmail3"
								>
									Agama Pasangan
								</Label>
								<Col sm="9">
									{/* <input
                      className="form-control"
                      id="agama_pasangan"
                      type="text"
                      readOnly={formData.formPasangan ===  "" ? false : true}
                      required
                      placeholder="Agama Pasangan"
                      defaultValue={dt.agama_pasangan}
                      value={dt.agama_pasangan}
                      onChange={e => changeInputText(e, "agama_pasangan")}

                      style={formData.formPasangan ===  "" ? { backgroundColor: "" } : { backgroundColor: "#c9d1d8" }}
                      disabled={formData.formPasangan ===  "" ? false : true}
                    /> */}
									{formData.formPasangan === "" ? (
										<div data-testid="selectAgama">
											<Select
												inputId="agama_pasangan"
												id="agama_pasangan"
												isDisabled={formData.formPasangan === "" ? false : true}
												classNamePrefix="select"
												onChange={((e) => { changeSelectValue(e, 'agama') })}
												defaultValue={formData.agmStat}
												value={formData.agmStat}
												name="Agama"
												options={formData.frmAgm}
												placeholder="Pilih Agama"
												isClearable
											/>
										</div>
									) : (
										<input
											id="agama_pasangan"
											type="text"
											className="form-control"
											readOnly
											value={dt.agama_pasangan}
											style={{ backgroundColor: "#c9d1d8" }}
										/>
									)}

								</Col>
							</FormGroup>

                            <FormGroup className="row">
                                <Label className="col-sm-3 col-form-label" htmlFor="inputEmail3">
                                    Alamat Pasangan
                                </Label>
                                <Col sm="9">
                                    <input
										data-testid="alamat_kk_pasangan"
										name="alamat_kk_pasangan"
										className="form-control"
										id="alamat_kk_pasangan"
										type="text"
										readOnly={formData.formPasangan === "" ? false : true}
										required
										placeholder="Contoh : Jalan Sudirman No. 2 Kec. Bandar Sari, Kab. Kampar, Riau"
										defaultValue={dt.alamat_kk_pasangan}
										value={dt.alamat_kk_pasangan}
										onChange={e => changeInputText(e, "alamat_kk_pasangan")}

										style={formData.formPasangan === "" ? { backgroundColor: "" } : { backgroundColor: "#c9d1d8" }}
										disabled={formData.formPasangan === "" ? false : true}
									/>
                                </Col>
                            </FormGroup>
                            <FormGroup className="row">
                                <Label className="col-sm-3 col-form-label" htmlFor="inputEmail3">
                                    Wilayah Pasangan
                                </Label>
                                <Col sm="9">
                                    <input
										data-testid="alamat_pasangan"
										name="alamat_pasangan"
										className="form-control"
										id="alamat_pasangan"
										type="text"
										readOnly={formData.formPasangan === "" ? false : true}
										required
										placeholder="Contoh : RT. 02/RW. 02, Dusun Bukit Durian, Desa Sungkur, Kec. Kampar Kiri Hilir, Kab. Kampar, Riau"
										defaultValue={dt.alamat_pasangan}
										value={dt.alamat_pasangan}
										onChange={e => changeInputText(e, "alamat_pasangan")}

										style={formData.formPasangan === "" ? { backgroundColor: "" } : { backgroundColor: "#c9d1d8" }}
										disabled={formData.formPasangan === "" ? false : true}
									/>
                                    {
                                        formData.formPasangan === ""
                                        ?
                                            <small><font color="red">* Contoh : RT. 02/RW. 02, Dusun Bukit Durian, Desa Sungkur, Kec. Kampar Kiri Hilir, Kab. Kampar, Riau</font></small>
                                        :
                                            <small><font color="red">* Jika data wilayah kosong, silahkan perbaiki data alamat kartu keluarga dan pastikan data lengkap terlebih dahulu</font></small>
                                    }
                                </Col>
                            </FormGroup>
							{ }
						</div>
						<hr />

						<FormGroup className="row">
							<Label
								className="col-sm-3 col-form-label"
								htmlFor="inputEmail3"
							>
								Tempat Nikah
							</Label>
							<Col sm="9">
								<input
									data-testid="tempat nikah"
									name="tempat_nikah"
									className="form-control"
									id="tempat_nikah"
									type="text"
									required
									placeholder="Contoh : KUA Marpoyan"
									defaultValue={dt.tempat_nikah}
									onFocus={e => e.currentTarget.select()}
								/>
							</Col>
						</FormGroup>
					</div>
					<div className="modal-footer">
						<button
							type="button"
							className="btn btn-warning"
							onClick={() => {
								// Tutup modal
								setFormData({
									...formData,
									status: {
										...formData.status,
										form: false
									}
								})
								setIsOpen(false)
							}}
						>
							Tutup
						</button>
						<button
							data-testid="btnSubmitCreate"
							type="submit"
							className="btn btn-primary-custom"
						// disabled={formData.status.btnForm}
						>
							Simpan
						</button>
					</div>
				</div>
			</Form>
		</Modal>
	);
}

export default ModalSuratPindahNikah;
